/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */



$(document).on('click', '.swatchColor', function(){
	var dataId = $(this).attr("data-name");
	var result = dataId.replace(" ", "_");
	var val = "."+result.toLowerCase();
  	$(val+" a img").trigger("click");
  	var id = $(val+" a").attr('href');
	var href = $(id).attr("data-image-position-ignoring-video");
  $(".flickity-slider").css("transform","translateX(-"+href+"00%)");

});

$(document).ready(function(){
	setTimeout(function(){ 
		$("button.Popover__Value.Heading.Link.Link--primary.u-h6:nth-child(1)").trigger("click");
    }, 1500);
});

$(document).ready(function(){
	var clickBtn = false;
  	setTimeout(function(){ 
      var val= $("span").hasClass("webyzeTooltip");
      if (val) {
      	//alert(val);
		$(".ProductForm__Variants .ProductForm__Option:first").append("<h1 class='unclicked ProductMeta__Title Heading u-h2'>Select Your Background Below</h1>");
      } else {
        $("button.ProductForm__AddToCart.Button.Button--full.Button--secondary").css("pointer-events","all");
        $(".shopify-payment-button").css("pointer-events","all");
		$(".Button--secondary, .shopify-payment-button__button").css("color","white");
        $(".Button--secondary, .shopify-payment-button__button").css("background-color","black");
      }
    }, 1500);
  	setTimeout(function(){
      	var val= $("span").hasClass("webyzeTooltip");
      	if (val) { } else {
	    	$(".shopify-payment-button__button").css("color","white");
    	    $(".shopify-payment-button__button").css("background-color","black");
        }
    }, 3000);
    $(document).on('click', '.swatchColor', function(e){
        if(clickBtn == false){
            e.preventDefault();
        }else{
        	$("button.ProductForm__AddToCart.Button.Button--full.Button--secondary").css("pointer-events","all");
			$(".shopify-payment-button").css("pointer-events","all");
          	$(".unclicked").hide();
          	$(".Button--secondary, .shopify-payment-button__button").css("color","white");
          	$(".Button--secondary, .shopify-payment-button__button").css("background-color","black");
        }
        clickBtn = true;
    });
	$(document).on('click', 'button.Popover__Value.Heading.Link.Link--primary.u-h6', function(e){
      var val= $("span").hasClass("webyzeTooltip");
      if (val) {
      	$(".unclicked").show();
		$(".shopify-payment-button").css("pointer-events","none");
		$(".shopify-payment-button__button").css("color","#6a6a6a");
		$(".shopify-payment-button__button").css("background-color","white");
		$(".shopify-payment-button__button").css("border","1px solid rgba(106,106,106,0.2)");
      } else {
        $("button.ProductForm__AddToCart.Button.Button--full.Button--secondary").css("pointer-events","all");
        $(".shopify-payment-button").css("pointer-events","all");
		$(".Button--secondary, .shopify-payment-button__button").css("color","white");
        $(".Button--secondary, .shopify-payment-button__button").css("background-color","black");
      }
    });
});


//$(".swatchColor.swatchType_image").trigger("click");